// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2RjhV","colMaxWidth":"Table_colMaxWidth__2Num-"};